<template>
  <v-form :submit="submitUpdate">
    <v-row density="compact">
      <v-col cols="12" sm="6">
        <v-row density="compact">
          <v-col cols="12">
            <v-text-field
                          label="Nome do grupo/tropa"
                          v-model="editSubGroup.name"
                          :rules="rules.required"
                          density="compact"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                          label="URL da imagem do grupo/tropa"
                          v-model="editSubGroup.img"
                          density="compact"></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6">
        <v-row density="compact">
          <v-col cols="12" class="text-center">
            <v-img class="fill-height"
                   :src="editSubGroup.img || assets.campfire"
                   max-height="70px"
                   inline>
            </v-img>
          </v-col>
          <v-col cols="12">
            <UploadFile
                        accept-type="image/png, image/jpeg, image/bmp"
                        icon="mdi-image"
                        :fileType="$FILE_TYPE.sub_group_image"
                        :userId="user.id"
                        :subGroupId="editSubGroup.id"
                        density="compact"
                        @uploaded="uploadedSubGroupImage" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-textarea
                    label="Descrição"
                    v-model="editSubGroup.description"
                    hide-details
                    density="compact"
                    counter></v-textarea>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          label="Ramo (opcional)"
          v-model="editSubGroup.ramo"
          :items="ramos"
          item-title="title"
          item-value="value"
          clearable
          density="compact"
          :disabled="requestingApi"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="chefeIds"
          v-model:search="chefeSearch"
          :items="chefeItems"
          item-title="title"
          item-value="value"
          label="Chefes"
          multiple
          chips
          closable-chips
          density="compact"
          hide-details="auto"
          :loading="loadingChefes"
          :disabled="requestingApi"
          no-filter
        />
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="success" type="submit"><v-icon class="mr-2">mdi-content-save</v-icon> Salvar</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>

import AutocompleteSelectGroup from './AutocompleteSelectGroup.vue';
import ListFromTo from "./ListFromTo.vue";
import UploadFile from "./UploadFile.vue";
import assets from "../assets/assets";
import api from '@/services'
import functions from '@/services/Functions'
import { TROPA_RAMOS } from '@/services/group'

export default {
  components: { ListFromTo, UploadFile, AutocompleteSelectGroup },
  props: {
    user: Object,
    subGroup: Object,
    admin: Boolean,
  },
  data() {
    return {
      assets: assets,
      requestingApi: null,
      editSubGroup: {},
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
      },
      ramos: TROPA_RAMOS,
      chefeSearch: '',
      chefeOptions: [],
      loadingChefes: false,
      chefeIds: [],
      searchTimeout: null,
    };
  },
  created() {
    var vm = this;
    vm.editSubGroup = vm.subGroup || vm.generateEmpty();
    vm.syncChefeIdsFromEdit();
  },
  mounted() { },
  activated() { },
  methods: {
    // selectedNewGroup(group) {
    //   var vm = this
    //   vm.editSubGroup.group_id = group?.id
    // },
    chefeId(chefe) {
      return chefe?.legal_person_id || chefe?.id
    },
    syncChefeIdsFromEdit() {
      var vm = this;
      const chefes = vm.editSubGroup?.chefes || [];
      vm.chefeIds = chefes.map((c) => vm.chefeId(c)).filter(Boolean);
      vm.chefeOptions = [];
      chefes.forEach((chefe) => vm.mergeChefeOption(chefe));
    },
    mergeChefeOption(chefe) {
      if (!chefe) return;
      const id = this.chefeId(chefe);
      if (!id) return;
      const ix = this.chefeOptions.findIndex((c) => this.chefeId(c) === id);
      if (ix >= 0) {
        this.chefeOptions.splice(ix, 1, { ...this.chefeOptions[ix], ...chefe });
      } else {
        this.chefeOptions.push(chefe);
      }
    },
    onChefeSearch(q) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      const text = (q || '').trim();
      if (text.length < 2) {
        this.loadingChefes = false;
        return;
      }
      this.loadingChefes = true;
      this.searchTimeout = setTimeout(() => {
        this.searchTimeout = null;
        this.loadChefes(text);
      }, 400);
    },
    loadChefes(searchText) {
      var vm = this;
      const text = (searchText || '').trim();
      if (text.length < 2) {
        vm.loadingChefes = false;
        return Promise.resolve();
      }
      vm.loadingChefes = true;
      return api.subGroup
        .searchChefes({ searchText: text })
        .then((result) => {
          const list = Array.isArray(result) ? result : [];
          list.forEach((chefe) => vm.mergeChefeOption(chefe));
        })
        .catch((err) => {
          if (err?.message) {
            vm.$notify({
              type: "warn",
              text: err.message,
            });
          }
        })
        .finally(() => {
          vm.loadingChefes = false;
        });
    },
    submitUpdate() {
      var vm = this;
      if (!vm.editSubGroup.group_id) {
        let _group = api.storage.selectedGroup();
        vm.editSubGroup.group_id = _group?.id
      }
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.subGroup
          .update({
            ...vm.editSubGroup,
            chefes: (vm.chefeIds || []).map((id) => ({ legal_person_id: id })),
          })
          .then((result) => {
            vm.$emit("updated", result);
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    uploadedSubGroupImage(image) {
      var vm = this
      vm.editSubGroup.img = image.path
    },
    generateEmpty() {
      return {
        acronym: null,
        name: null,
        description: null,
        img: null,
        configuration: null,
        ramo: null,
        chefes: [],
      };
    },
  },
  computed: {
    chefeItems() {
      return (this.chefeOptions || []).map((c) => {
        const id = this.chefeId(c);
        const name = c?.name || '';
        const email = c?.email || '';
        return {
          title: email ? `${name} (${email})` : (name || `#${id}`),
          value: id,
        };
      });
    },
  },
  watch: {
    subGroup(newVal) {
      console.debug('GROUP changed', newVal)
      this.editSubGroup = newVal || this.generateEmpty();
      this.syncChefeIdsFromEdit();
    },
    chefeSearch(newVal) {
      this.onChefeSearch(newVal);
    },
  },
};
</script>